export default __webpack_public_path__ + "static/media/scenario-icon.e157b714.svg";